App.factory('contactService', ['$q', 'baseService', 'Config', function($q, baseService, Config) {
    function ContactService() {
        this.contactForm = function(data) {
            return baseService.confirm(Config.API_URL + '/contactForm', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };
        
    }
    return new ContactService();
}]);